import posthog from "posthog-js";
import * as Sentry from "@sentry/react";
import { isMyAppWKWebView } from "./isMyAppWKWebView";

// let locationRequestOnLoad = true;

export async function getLocation(force: boolean): Promise<[number, number]> {
  const startTime = performance.now();

  if (window.Android) {
    throw new Error("Unsupported platform");
  }

  if (isMyAppWKWebView()) {
    const returnPromise =
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      (window.webkit as any).messageHandlers.getLocation.postMessage(force);

    return returnPromise.finally(() => {
      const endTime = performance.now();
      posthog.capture("getLocation_return", {
        duration: endTime - startTime,
      });
    });
  }

  try {
    // return [31, -100]
    // if (locationRequestOnLoad) {
    //   setTimeout(() => {
    //     locationRequestOnLoad = false;
    //   }, 500);
    //   await new Promise(resolve => setTimeout(resolve, 1000000));
    //   throw new Error("Ignore this error.");
    // }

    if (!navigator.geolocation) {
      throw new Error("Geolocation not supported in this browser");
    }

    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        reject,
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });

    const endTime = performance.now();
    posthog.capture("getLocation_return", {
      duration: endTime - startTime,
      platform: 'web'
    });
    
    return [position.coords.latitude, position.coords.longitude];
  } catch (error) {
    const err = error as GeolocationPositionError;
    
    if (err.code === 1) {
      Sentry.captureException(error, {
        extra: { location_error: 'Permission denied' }
      });
      throw new Error("Location permission denied");
    }
    
    Sentry.captureException(error);
    throw error;
  }
}
